"use strict";
/** @module BryxApi.SupportApi */
Object.defineProperty(exports, "__esModule", { value: true });
var ImageMixin = /** @class */ (function () {
    function ImageMixin() {
    }
    ImageMixin.prototype.getImageUrl = function (imageId) {
        return this.apiRoot + "/images/" + imageId + "?apiKey=" + this.local.apiKey;
    };
    return ImageMixin;
}());
exports.default = ImageMixin;
//# sourceMappingURL=ImageMixin.js.map